import React, { useState, useEffect } from 'react'
import { FormControlLabel, Switch as MuiSwitch } from '@mui/material'

interface ISwitchProps {
  checked: boolean
  name?: string
  id?: string
  disabled?: boolean
  color?: 'primary' | 'secondary'
  onChange?: (checked: boolean) => void
  label: string
  description?: string
}

const Switch: React.FC<ISwitchProps> = (props) => {
  const color: 'primary' | 'secondary' = props.color || 'primary'
  const [checked, setChecked] = useState(props.checked)

  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  const handleChange = (checked: boolean) => {
    setChecked(checked)
    props.onChange && props.onChange(checked)
  }

  return (
    <FormControlLabel
      control={
        <MuiSwitch
          checked={checked}
          id={props.id}
          disabled={props.disabled}
          onChange={((event: React.ChangeEvent<HTMLInputElement>) => handleChange(event.target.checked))}
          color={color}
          name={props.name}
        />
      }
      label={props.label}
    />
  )
}

export default Switch
